import { render, staticRenderFns } from "./WeChat.vue?vue&type=template&id=46063780&scoped=true&"
import script from "./WeChat.vue?vue&type=script&lang=js&"
export * from "./WeChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46063780",
  null
  
)

export default component.exports